<template>
    <div id="main">
        <p class="title-header"><i class="fa-solid fa-bookmark"></i> {{ lesson.lesson_name }}</p>
        <div data-toggle="collapse" data-target="#introLesson" class="mb-1">
            <p v-tippy="{content: 'Collapse Mô tả bài học'}" class="p-description color-span-first"><i class="fa-solid fa-book"></i> Mô tả về bài học </p>
        </div>
        <div class="collapse show mb-2" id="introLesson">
            <div class="card card-body" v-html="lesson.lesson_introduce"></div>
        </div>
        <div class="video-lesson">
            <!-- loại bỏ các thuộc tính này khỏi thẻ video để vô hiệu hóa tính năng chặn tua video
                @seeking="restrictSeeking"
                @seeked="handleSeeked"
            -->
            <video
                ref="videoPlayer"
                controls
                @contextmenu.prevent
                controlsList="nodownload"
                @timeupdate="updateWatchedTime"
                @loadeddata="initVideo"
            >
                <source :src="lesson.lesson_video" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div v-if="isLoading" class="loading-spinner">Đang tải video...</div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue';
import UserRequest from '@/restful/UserRequest';

export default {
    name: "LessonComponent",
    props: {
        lesson: Object,
        chapter: Object,
        course: Object,
        startTime: {
            type: Number,
            default: 0 // Thời gian bắt đầu mặc định là 0 giây
        }
    },
    data() {
        return {
            watchedTime: 0, // Thời gian lớn nhất đã xem (tính bằng giây)
            isLoading: true, // Trạng thái loading
            initialTime: 0, // Lưu thời gian ban đầu từ startTime
            lastSaveTime: 0, // Thời gian lần cuối gửi yêu cầu API
            saveInterval: 1200000, // Khoảng thời gian tối thiểu giữa các yêu cầu API (2 phút)
        };
    },
    mounted() {
        this.$emit('eventActiveTab', '');
        // Khởi tạo video sau khi DOM sẵn sàng
        this.initVideo();
    },
    watch: {
        'lesson.lesson_video': {
            handler() {
                this.isLoading = true;
                this.watchedTime = 0; // Reset thời gian xem khi video thay đổi
                this.initialTime = 0; // Reset initialTime khi video thay đổi
                // Chờ DOM cập nhật trước khi khởi tạo video
                nextTick(() => {
                    this.initVideo();
                });
            },
            immediate: true,
        }
    },
    methods: {
        initVideo() {
            // Đảm bảo video đã sẵn sàng trước khi khởi tạo
            const video = this.$refs.videoPlayer;
            if (video) {
                // Sử dụng startTime từ prop, đã được LessonAndChat xử lý
                this.initialTime = this.startTime;
                this.watchedTime = this.startTime;
                video.currentTime = this.startTime;
                this.isLoading = false;
            }
        },
        // Vẫn giữ tracking tiến độ
        updateWatchedTime() {
            const video = this.$refs.videoPlayer;
            // Chỉ cập nhật nếu video chưa hoàn thành
            if (video && !video.seeking && (!this.lesson.lesson_completed || this.lesson.lesson_completed.completed !== 1)) {
                // Cập nhật thời gian xem lớn nhất
                if (video.currentTime > this.watchedTime) {
                    this.watchedTime = video.currentTime;
                    // Kiểm tra xem video đã hoàn thành chưa
                    if (video.duration && video.duration - video.currentTime < 1) {
                        this.saveWatchedTime(true); // Gửi với completed: 1
                    } else {
                        this.saveWatchedTime(); // Gửi bình thường
                    }
                }
                // Tắt trạng thái loading khi video bắt đầu phát
                if (this.isLoading) {
                    this.isLoading = false;
                }
            }
        },
        // Vô hiệu hóa tính chặn năng tua video
        /*
        restrictSeeking() {
            const video = this.$refs.videoPlayer;
            // Chỉ hạn chế tua nếu video chưa hoàn thành
            if (video && (!this.lesson.lesson_completed || this.lesson.lesson_completed.completed !== 1)) {
                if (video.currentTime > this.watchedTime + 0.1) {
                    video.currentTime = this.watchedTime;
                    this.$emitEvent('eventWarning', 'Bạn chỉ có thể tua trong phần video đã xem !');
                }
            }
        },
        handleSeeked() {
            const video = this.$refs.videoPlayer;
            // Chỉ hạn chế tua nếu video chưa hoàn thành
            if (video && (!this.lesson.lesson_completed || this.lesson.lesson_completed.completed !== 1)) {
                if (video.currentTime > this.watchedTime) {
                    video.currentTime = this.watchedTime;
                }
            }
        },
        */
        saveWatchedTime: async function (completed = false) {
            // Lưu vào localStorage ngay lập tức
            localStorage.setItem(`watchedTime_${this.lesson.id}`, this.watchedTime);

            // Chỉ gửi API nếu watchedTime vượt quá initialTime
            if (this.watchedTime <= this.initialTime) {
                return;
            }

            // Throttle yêu cầu API (mỗi 2 phút)
            const currentTime = Date.now();
            if (currentTime - this.lastSaveTime < this.saveInterval && !completed) {
                return; // Bỏ qua nếu chưa đủ 2 phút, trừ khi video hoàn thành
            }

            try {
                const data_submit = {
                    lesson_id: this.lesson.id,
                    time: this.watchedTime,
                    completed: completed ? 1 : 0,
                };
                const { data } = await UserRequest.post('lesson-completed', data_submit);
                console.log(data);
                this.lastSaveTime = currentTime; // Cập nhật thời gian gửi yêu cầu cuối
                if(completed === true) {
                    this.$emitEvent('eventSuccess', 'Chúc mừng bạn đã hoàn thành video bài học này !');
                }
            } catch (error) {
                if (error.messages) this.$emit('eventError', error.messages[0]);
            }
        },
    }
}
</script>

<style scoped>
.video-lesson {
    margin-top: 10px;
}
video {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    border-radius: 6px;
}
.loading-spinner {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #007BFF;
}
/* Các style khác giữ nguyên như mã gốc */
</style>